module.exports = __webpack_public_path__ + "static/media/shouting.eec57cd9.mp4";